import { IDropdownOption, TextField } from "@fluentui/react";
import { Utils } from "../../../common/views/Utils";
import { NewProductModel } from "../../models/NewProductModel";

export type ProductInputProps = {
    form: NewProductModel;
    lineIndex: number;
    productIndex: number;
    sizeOptions: IDropdownOption[];
    onValueChange: <K extends keyof NewProductModel>(
        lineIndex: number, productIndex: number, field: K, value: NewProductModel[K]
    ) => void;
}

export default function ProductInputView({
    form, lineIndex, productIndex, sizeOptions, onValueChange
}: ProductInputProps) {
    const className1 = Utils.getColumnWidth(1);
    const className3 = Utils.getColumnWidth(3);

    const getKey = () => {
        let key = getSizeText();

        if (!Utils.isNullOrEmpty(key) && !Utils.isNullOrEmpty(form.code)) {
            key += " / ";
        }

        if (!Utils.isNullOrEmpty(form.code)) {
            key += form.code;
        }

        return key;
    }

    const getSizeText = () => {
        if (form.sizeId && sizeOptions) {
            for (let i = 0; i < sizeOptions.length; i++) {
                if (sizeOptions[i].key === form.sizeId) {
                    return sizeOptions[i].text;
                }
            }
        }

        return "";
    }

    const getTotal = () => {
        let price = parseFloat(form.price.toString());
        let shipping = parseFloat(form.shipping.toString());
        let fee = parseFloat(form.fee.toString());

        return price + shipping + fee;
    }

    const onChange = <K extends keyof NewProductModel>(field: K, value: NewProductModel[K]) => {
        console.log("from input " + field + ": " + value);
        onValueChange(lineIndex, productIndex, field, value);
    }

    const barcodeInput = () => {
        return <div className="pb-10">
            <TextField
                label=""
                value={form.barcode}
                onChange={(_, v) => onChange("barcode", v || "")} />
        </div>;
    }

    const msrpInput = () => {
        return <div className="pb-10">
            <TextField
                label=""
                value={form.msrp.toString()}
                type={"number"}
                onChange={(_, v) => onChange("msrp", Number(v))} />
        </div>;
    }

    const priceInput = () => {
        return <div className="pb-10">
            <TextField
                label=""
                value={form.price.toString()}
                type={"number"}
                onChange={(_, v) => onChange("price", Number(v))} />
        </div>;
    }

    const shippingInput = () => {
        return <div className="pb-10">
            <TextField
                label=""
                value={form.shipping.toString()}
                type={"number"}
                onChange={(_, v) => onChange("shipping", Number(v))} />
        </div>;
    }

    const feeInput = () => {
        return <div className="pb-10">
            <TextField
                label=""
                value={form.fee.toString()}
                type={"number"}
                onChange={(_, v) => onChange("fee", Number(v))} />
        </div>;
    }

    return <div className="ms-Grid-row">
        <div className={className3 + " pt-5"}>
            {getKey()}
        </div>
        <div className={className3}>
            {barcodeInput()}
        </div>
        <div className={className1}>
            {msrpInput()}
        </div>
        <div className={className1}>
            {priceInput()}
        </div>
        <div className={className1}>
            {shippingInput()}
        </div>
        <div className={className1}>
            {feeInput()}
        </div>
        <div className={className1 + " pt-5 font-bold right"}>
            {getTotal().toFixed(2)}
        </div>
    </div>;
}